import { decrypt } from "../decrypt";

function getReadableGcashResponse(datatodecrypt) {
    // let decParams = Buffer.from(datatodecrypt, "base64").toString(); // Buffer is only available only in node.js environment
    let decParams = atob(datatodecrypt); // we use atob since we are in a browser environment.
    return JSON.parse(decrypt(decParams));
}

export { getReadableGcashResponse };
